import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, vModelText as _vModelText } from "vue"

const _hoisted_1 = { class: "maincontainer py-8 px-4" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "flex justify-between" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("h1", null, "Create task")
  ])
], -1)
const _hoisted_3 = { class: "card shadow-2xl p-4 mt-4" }
const _hoisted_4 = { class: "w-1/2 mt-4" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", { class: "controllabel font-normal text-sm mb-1" }, "Please select process:", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("option", null, "Please select one", -1)
const _hoisted_7 = ["value"]
const _hoisted_8 = { class: "flex justify-between w-100 mt-4" }
const _hoisted_9 = {
  key: 0,
  class: "w-1/3"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", { class: "controllabel font-normal text-sm mb-1" }, "Status:", -1)
const _hoisted_11 = ["value"]
const _hoisted_12 = { class: "w-1/3 ml-5" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", { class: "controllabel font-normal text-sm mb-1" }, "Created by:", -1)
const _hoisted_14 = { class: "inputboxstyling" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("option", null, "Please select one", -1)
const _hoisted_16 = ["value"]
const _hoisted_17 = { class: "w-1/3 ml-5" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("label", { class: "controllabel font-normal text-sm mb-1" }, "Assignee:", -1)
const _hoisted_19 = { class: "inputboxstyling" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("option", null, "Please select one", -1)
const _hoisted_21 = ["value"]
const _hoisted_22 = {
  key: 0,
  class: "flex justify-between w-100 mt-4"
}
const _hoisted_23 = { key: 0 }
const _hoisted_24 = { class: "controllabel font-normal text-sm mb-1" }
const _hoisted_25 = ["onUpdate:modelValue"]
const _hoisted_26 = { key: 1 }
const _hoisted_27 = { class: "controllabel font-normal text-sm mb-1" }
const _hoisted_28 = ["onUpdate:modelValue"]
const _hoisted_29 = { key: 2 }
const _hoisted_30 = { class: "controllabel font-normal text-sm mb-1" }
const _hoisted_31 = ["onUpdate:modelValue"]
const _hoisted_32 = /*#__PURE__*/_createElementVNode("option", null, "Please select one", -1)
const _hoisted_33 = { class: "flex justify-center mt-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _withDirectives(_createElementVNode("select", {
          class: "inputboxstyling",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedProcess) = $event)),
          onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.getProcessData($event)))
        }, [
          _hoisted_6,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.processes, (process) => {
            return (_openBlock(), _createElementBlock("option", {
              value: process._id,
              key: process._id
            }, _toDisplayString(process.name), 9, _hoisted_7))
          }), 128))
        ], 544), [
          [_vModelSelect, _ctx.selectedProcess]
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        (_ctx.showControls)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _hoisted_10,
              _withDirectives(_createElementVNode("select", {
                class: "inputboxstyling",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedStatus) = $event))
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.processData.workFlowData.statuses, (status, statusIndex) => {
                  return (_openBlock(), _createElementBlock("option", {
                    value: statusIndex,
                    key: statusIndex
                  }, _toDisplayString(status.label), 9, _hoisted_11))
                }), 128))
              ], 512), [
                [_vModelSelect, _ctx.selectedStatus]
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_12, [
          _hoisted_13,
          _createElementVNode("select", _hoisted_14, [
            _hoisted_15,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.teams, (team) => {
              return (_openBlock(), _createElementBlock("option", {
                value: team,
                key: team._id
              }, _toDisplayString(team.teamName), 9, _hoisted_16))
            }), 128))
          ])
        ]),
        _createElementVNode("div", _hoisted_17, [
          _hoisted_18,
          _createElementVNode("select", _hoisted_19, [
            _hoisted_20,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.teams, (team) => {
              return (_openBlock(), _createElementBlock("option", {
                value: team,
                key: team._id
              }, _toDisplayString(team.teamName), 9, _hoisted_21))
            }), 128))
          ])
        ])
      ]),
      (_ctx.showControls)
        ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.processData.configurationData.controls, (control, controlIndex) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "controls flex",
                key: controlIndex
              }, [
                (control.controlType == 'TextBox')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                      _createElementVNode("label", _hoisted_24, _toDisplayString(control.label) + ":", 1),
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        class: "inputboxstyling",
                        "onUpdate:modelValue": ($event: any) => ((control.value) = $event)
                      }, null, 8, _hoisted_25), [
                        [_vModelText, control.value]
                      ])
                    ]))
                  : (control.controlType == 'TextArea')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                        _createElementVNode("label", _hoisted_27, _toDisplayString(control.label) + ":", 1),
                        _withDirectives(_createElementVNode("textarea", {
                          rows: "4",
                          cols: "50",
                          style: {"border":"1px solid gray"},
                          "onUpdate:modelValue": ($event: any) => ((control.value) = $event)
                        }, null, 8, _hoisted_28), [
                          [_vModelText, control.value]
                        ])
                      ]))
                    : (control.controlType == 'Dropdown')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                          _createElementVNode("label", _hoisted_30, _toDisplayString(control.label) + ":", 1),
                          _withDirectives(_createElementVNode("select", {
                            class: "inputboxstyling",
                            "onUpdate:modelValue": ($event: any) => ((control.value) = $event)
                          }, [
                            _hoisted_32,
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(control.options, (option, optionIndex) => {
                              return (_openBlock(), _createElementBlock("option", { key: optionIndex }, _toDisplayString(option.option), 1))
                            }), 128))
                          ], 8, _hoisted_31), [
                            [_vModelSelect, control.value]
                          ])
                        ]))
                      : _createCommentVNode("", true)
              ]))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_33, [
        _createElementVNode("button", {
          class: "btnprimary",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.generaTask()))
        }, "Generate")
      ])
    ])
  ]))
}